import { useState } from 'react';

import Tracker from '~/src/common/services/Tracker';

export interface ChangeServingsAnalyticsInfo {
  recipe?: {
    id: string;
    name: string;
    type: string;
  };
  categoryName?: string;
  subcategoryName?: string;
  location: 'top of ingredients list' | 'near CTA';
}

const useServings = () => {
  const [servings, setServings] = useState<number>();

  const handleChangeServings = (
    value: number,
    { recipe, categoryName, subcategoryName, location }: ChangeServingsAnalyticsInfo,
  ) => {
    if (servings) {
      Tracker.sendEvent(value > servings ? 'click add portion' : 'click remove portion', {
        'portion quantity': value,
        'click location': location,
        'recipe id': recipe?.id ?? '',
        'recipe name': recipe?.name ?? '',
        'recipe category': categoryName,
        'recipe subcategory': subcategoryName,
        'recipe type': recipe?.type,
      });
    }

    setServings(value);
  };

  return {
    servings,
    handleChangeServings,
    handleInitialServings: setServings,
  };
};

export default useServings;
